import * as angular from "angular";
import { PlotService } from "@services/plot.service";

export function degreesToCompassTerm(plotService: PlotService) {
    return (input: number) => {
        return plotService.convertDirectionToWords(input);
    }
}
